import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center text-center py-20 px-4 rounded-lg border border-dashed border-background-300 bg-background-100/60">
      <span className="w-16 h-16 rounded-full bg-background-200 text-foreground-400 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="font-heading font-semibold text-lg text-foreground-950">{title}</h3>
      <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      {actionLabel && (
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {onAction && (
            <button
              type="button"
              onClick={onAction}
              className="h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {actionLabel}
            </button>
          )}
          {actionTo && (
            <Link
              to={actionTo}
              className="h-10 px-5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
          )}
        </div>
      )}
    </div>
  );
}